<ng-content select="[xHeader]"></ng-content>
<ng-content select="x-page-row"></ng-content>
<ng-content select="[xContent]"></ng-content>

<ng-content select="[xFooter]"></ng-content>
